export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11479.7eb97708.jpg";